import { memo } from 'react';
import { useIntl } from 'react-intl';
import { Navigate } from 'react-router-dom';
import { Heading, TextBlock } from '@library';
import useSalePage from '../../../core/queries/useSalePage';
import FeaturedFilter from '../ProductList/Filters/FeaturedFilter';
import useCategory from '../../../core/queries/useCategory';
import { FluidProgressIndicator } from '../../../core/components/ProgressIndicators';
import ProductList from '../ProductList/List/ProductList';
import withErrorBoundary from '../../../core/components/errors/withErrorBoundary';
import SaleTile from './SaleTile';
import salePageStyles from './SalePage.module.scss';

const Header = withErrorBoundary(
    memo(() => {
        const intl = useIntl();
        const { categoryId, categoryName } = useCategory();

        return (
            <Heading h3 bold>
                {categoryId ? (
                    `${categoryName}`
                ) : (
                    <>
                        {' '}
                        {intl.formatMessage({
                            id: 'all categories',
                        })}
                    </>
                )}
            </Heading>
        );
    })
);

const SalePage = () => {
    const intl = useIntl();
    const { data, loadingContent } = useSalePage();

    if (!data && !loadingContent) {
        return <Navigate to="../../" />;
    }

    return (
        <ProductList
            isSalePage
            ignoreList={['q', 'onSale', 'states']}
            featuredFilter={
                <FeaturedFilter
                    hideSearchResultsForText
                    name={intl.formatMessage({
                        id: 'sales page',
                    })}
                    value={data?.filter_headline}
                    additionalInfo={
                        <TextBlock tertiary>{data?.filter_tagline}</TextBlock>
                    }
                />
            }
            filters={{
                includeExcludedCategories: false,
            }}
            header={<Header />}
            banner={
                loadingContent || !data ? (
                    <div className={salePageStyles.progressIndicatorContainer}>
                        <FluidProgressIndicator />
                    </div>
                ) : (
                    <SaleTile
                        content={{
                            image: data.banner_image,
                            description: data.description,
                            title: data.headline,
                            link_target: '',
                        }}
                    />
                )
            }
            rootLinks={[
                {
                    messageId: 'sales page',
                    to: '/sale',
                },
            ]}
            isSearchResultPage
        />
    );
};

export default memo(withErrorBoundary(SalePage));
